import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Eye, IndianRupee, MessageCircle, MousePointerClick, Navigation, Phone, QrCode, RefreshCw } from "lucide-react";
import { API } from "@/lib/site";

const inr = (value) => `₹${Number(value || 0).toLocaleString("en-IN")}`;
const RANGES = [["tonight", "Tonight"], ["week", "This week"], ["all", "All time"]];

export const InsightsPanel = ({ token }) => {
  const [insights, setInsights] = useState(null);
  const [range, setRange] = useState("all");
  const [day, setDay] = useState("");
  const load = useCallback(async (r, d) => {
    try {
      const useDay = d !== undefined ? d : day;
      const url = useDay ? `${API}/insights?date=${useDay}` : `${API}/insights?range=${r || range}`;
      const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
      setInsights(response.data);
    } catch (error) { if (error.response?.status === 401) { localStorage.removeItem("soho_staff_token"); window.location.reload(); } }
  }, [token, range, day]);
  useEffect(() => { load(range, day); }, [range, day]);

  const totals = insights?.totals;
  return (
    <div className="insights" data-testid="insights-section">
      <div className="insights-head">
        <p className="kicker">Night insights</p>
        <div className="insights-filters">
          {RANGES.map(([key, label]) => (
            <button key={key} className={`filter-pill ${range === key && !day ? "active" : ""}`} onClick={() => { setDay(""); setRange(key); }} data-testid={`insights-filter-${key}`}>{label}</button>
          ))}
          <input type="date" className="filter-date" value={day} max={new Date().toISOString().slice(0, 10)} onChange={(e) => setDay(e.target.value)} data-testid="insights-date-filter" aria-label="Pick a day"/>
          <button className="text-button insight-refresh" onClick={() => load()} data-testid="refresh-insights-button"><RefreshCw size={12}/> Refresh</button>
        </div>
      </div>
      <div className="insight-totals">
        <div className="insight-stat" data-testid="insight-total-visits"><Eye size={16}/><strong>{totals ? totals.visits : "–"}</strong><span>Site visits</span></div>
        <div className="insight-stat" data-testid="insight-total-whatsapp"><MessageCircle size={16}/><strong>{totals ? totals.whatsapp : "–"}</strong><span>WhatsApp taps</span></div>
        <div className="insight-stat" data-testid="insight-total-calls"><Phone size={16}/><strong>{totals ? totals.calls : "–"}</strong><span>Call taps</span></div>
        <div className="insight-stat" data-testid="insight-total-directions"><Navigation size={16}/><strong>{totals ? totals.directions : "–"}</strong><span>Direction taps</span></div>
        <div className="insight-stat" data-testid="insight-total-covers"><QrCode size={16}/><strong>{totals ? totals.covers : "–"}</strong><span>Cover passes</span></div>
        <div className="insight-stat" data-testid="insight-total-revenue"><IndianRupee size={16}/><strong>{totals ? inr(totals.revenue) : "–"}</strong><span>Cover revenue</span></div>
      </div>
      <div className="insight-rows">
        <div className="insight-row head"><span>Event</span><span>Clicks</span><span>WhatsApp</span><span>Calls</span><span>Covers</span><span>Revenue</span></div>
        {insights?.events.map((row) => (
          <div className="insight-row" key={row.id} data-testid={`insight-row-${row.id}`}>
            <div className="insight-event"><strong>{row.title}</strong>{row.date && <span>{row.date} {row.month}</span>}</div>
            <div className="insight-cell"><MousePointerClick size={13}/>{row.clicks || 0}</div>
            <div className="insight-cell"><MessageCircle size={13}/>{row.whatsapp}</div>
            <div className="insight-cell"><Phone size={13}/>{row.calls}</div>
            <div className="insight-cell"><QrCode size={13}/>{row.covers}</div>
            <div className="insight-cell revenue">{inr(row.revenue)}</div>
          </div>
        ))}
        {insights && (insights.general.whatsapp > 0 || insights.general.calls > 0 || insights.general.directions > 0) && (
          <div className="insight-row" data-testid="insight-row-general">
            <div className="insight-event"><strong>General</strong><span>Site-wide · directions {insights.general.directions}</span></div>
            <div className="insight-cell"><MousePointerClick size={13}/>–</div>
            <div className="insight-cell"><MessageCircle size={13}/>{insights.general.whatsapp}</div>
            <div className="insight-cell"><Phone size={13}/>{insights.general.calls}</div>
            <div className="insight-cell"><QrCode size={13}/>–</div>
            <div className="insight-cell revenue">–</div>
          </div>
        )}
      </div>
    </div>
  );
};
